import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FinancialPlanWarning from '../FinancialPlanWarning/FinancialPlanWarningContainer';
import MobileGoalsSummaryEmptyState from '../CommonComponents/MobileGoalsSummaryEmptyState';
import {
  FINANCIAL_GOAL_TYPE_DICTIONARY,
  MOBILE_FINANCIAL_GOAL_TYPE_DICTIONARY,
  DEFAULT_SELECTION,
} from '../FinancialPlan/FinancialPlanComponentMap';

export default class FinancialPlanView extends Component {
  static load({ fpId, clientId, fetchData }, event) {
    fetchData(fpId, clientId, event);
  }

  constructor(props) {
    super(props);
    this.financialPlanUpdate = this.financialPlanUpdate.bind(this);
  }

  UNSAFE_componentWillMount() {
    const {
      clientId,
      routeGoalId,
      setGoalId,
      getConsumerApplicationVariables,
      isConsumerArea,
      consumerApplicationVariablesLoaded,
    } = this.props;
    document.addEventListener('refreshFinancialPlan', this.financialPlanUpdate);
    FinancialPlanView.load(this.props);
    if (routeGoalId) {
      setGoalId(routeGoalId, clientId);
    }
    const { params: routeParams } = ADV.util.Router.getObjFromHash(ADV.util.getHash());
    if (isConsumerArea && routeParams.workflowEnded && !consumerApplicationVariablesLoaded) {
      getConsumerApplicationVariables(clientId, routeParams.workflowEnded);
    }
  }

  componentDidMount() {
    const { clientId, useWhatIfsSidebar, setWhatIfsVisible } = this.props;
    setWhatIfsVisible(clientId, useWhatIfsSidebar);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { clientId, fpId, routeGoalId, setGoalId } = this.props;

    if (clientId !== newProps.clientId) {
      this.props.setWhatIfsVisible(clientId, false);
      this.props.setWhatIfsVisible(newProps.clientId, true);
    }

    const shouldReload = newProps.clientId !== clientId || newProps.fpId !== fpId;

    if (shouldReload) {
      FinancialPlanView.load(newProps);
    }

    if (newProps.routeGoalId !== routeGoalId) {
      setGoalId(routeGoalId, clientId);
    }
  }

  componentWillUnmount() {
    const {
      clientId,
      resetData,
      setWhatIfsVisible,
      clearGoalsSummary,
      clearFinancialPlanData,
    } = this.props;
    resetData(clientId);
    document.removeEventListener('refreshFinancialPlan', this.financialPlanUpdate);
    setWhatIfsVisible(clientId, false);
    clearFinancialPlanData(clientId);
    clearGoalsSummary();
  }

  financialPlanUpdate(event) {
    FinancialPlanView.load(this.props, event);
  }

  render() {
    const {
      clientId,
      selectedGoal,
      errorType,
      showConsumerContactFinancialAdviser,
      openContactFinancialAdviserModal,
    } = this.props;

    switch (errorType) {
      case 'PlanNotStarted':
      case 'MissingInfo':
        return <MobileGoalsSummaryEmptyState clientId={clientId} />;
      default:
        break;
    }

    const goalType = selectedGoal.GoalType || DEFAULT_SELECTION;
    let Content;

    if (MOBILE_FINANCIAL_GOAL_TYPE_DICTIONARY[goalType]) {
      Content = MOBILE_FINANCIAL_GOAL_TYPE_DICTIONARY[goalType];
    } else if (FINANCIAL_GOAL_TYPE_DICTIONARY[goalType]) {
      Content = FINANCIAL_GOAL_TYPE_DICTIONARY[goalType];
    }

    const { params: routeParams } = ADV.util.Router.getObjFromHash(ADV.util.getHash());

    if (showConsumerContactFinancialAdviser && routeParams.workflowEnded === 'true') {
      openContactFinancialAdviserModal(clientId);
    }

    return (
      <div className="NewFinancialPlan">
        <FinancialPlanWarning clientId={clientId} />
        {!Content && <div className="FinancialPlanModule" />}
        {Content && (
          <div className="FinancialPlanModule">
            <Content {...this.props} />
          </div>
        )}
      </div>
    );
  }
}

FinancialPlanView.defaultProps = {
  routeGoalId: null,
  errorType: null,
};

FinancialPlanView.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  errorType: PropTypes.string,
  whatIfsOpen: PropTypes.bool.isRequired,
  clientId: PropTypes.string.isRequired,
  routeGoalId: PropTypes.string,
  fpId: PropTypes.string.isRequired,
  setGoalId: PropTypes.func.isRequired,
  selectedGoal: PropTypes.shape({
    GoalId: PropTypes.string.isRequired,
    GoalType: PropTypes.string.isRequired,
  }).isRequired,
  setWhatIfsVisible: PropTypes.func.isRequired,
  resetData: PropTypes.func.isRequired,
  data: PropTypes.isRequired,
  clearGoalsSummary: PropTypes.func.isRequired,
  clearFinancialPlanData: PropTypes.func.isRequired,
  openContactAdviserModal: PropTypes.func.isRequired,
  showConsumerContactFinancialAdviser: PropTypes.bool.isRequired,
  getConsumerApplicationVariables: PropTypes.func.isRequired,
  consumerApplicationVariablesLoaded: PropTypes.bool.isRequired,
};
